import React from 'react'
import ScrollerPage from '../containers/commons/ScrollerPage'
import WindowDimensionsPage from '../containers/commons/WindowDimensionsPage'
import HeaderPage from '../containers/layout/HeaderPage'
import SidebarPage from '../containers/layout/SidebarPage'
import DocumentEditionPage from '../containers/dossiers/common/DocumentEdition'
import DocumentHistoricalEditionPage from '../containers/dossierHistorical/common/DocumentEdition'
import MessageModalContainer from '../containers/layout/modals/MessageModalContainer'
import ModalDocumentFullScreenPage from '../containers/dossiers/common/ModalDocumentFullScreenPage'

export default ({ children }) => {
  return (
    <div>
      <HeaderPage />
      <SidebarPage />
      <div className="layout">
        <MessageModalContainer />
        <DocumentEditionPage />
        <DocumentHistoricalEditionPage />
        <ModalDocumentFullScreenPage />
        <ScrollerPage />
        <WindowDimensionsPage />
        { children }
      </div>
    </div>
  )
}
